module.exports = __webpack_public_path__ + "static/media/day4.workshop.0b38ab8f.md";